import { memo } from 'react';

import SvgIcon from '@material-ui/core/SvgIcon';

import { colors } from '../theme';
import { SvgIconProps } from './SvgIcon.types';

export const TruckOutlinedIcon = memo(
  ({ fontSize = 18, color = colors.basic.black, className, style }: SvgIconProps) => (
    <SvgIcon
      width="22"
      height="15"
      viewBox="0 0 22 15"
      fill="none"
      className={className}
      style={{ fontSize, ...style }}
    >
      <svg width="22" height="15" viewBox="0 0 22 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8.04218 12.247V3.39001H3.15455C1.7327 3.47518 0.666307 4.66746 0.755173 6.03007V11.3954C0.755173 11.8212 1.11064 12.247 1.55497 12.3321H3.42115"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.75413 13.6096C5.46506 13.6096 6.08712 13.0134 6.08712 12.3321C6.08712 11.6508 5.46506 11.0547 4.75413 11.0547C4.0432 11.0547 3.42114 11.6508 3.42114 12.3321C3.42114 13.0134 3.95434 13.6096 4.75413 13.6096Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.4182 13.6096C16.1291 13.6096 16.7512 13.0134 16.7512 12.3321C16.7512 11.6508 16.1291 11.0547 15.4182 11.0547C14.7073 11.0547 14.0852 11.6508 14.0852 12.3321C14.0852 13.0134 14.6184 13.6096 15.4182 13.6096Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.755127 7.13719H4.66523C5.02069 7.22236 5.37615 6.8817 5.37615 6.45589V3.39001"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.08716 12.2471H14.0851"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.755127 9.69214H2.53244"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.7501 8.49985H8.04224V2.02745C8.04224 1.34614 8.6643 0.75 9.37522 0.75H19.3282C20.0391 0.75 20.6612 1.34614 20.6612 2.02745V8.49985H20.7501Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.751 12.247H19.417C20.1279 12.247 20.7499 11.6509 20.7499 10.9696V8.41467"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  ),
);
